import React from 'react';
import {
  Controller, FormProvider, UseFormReturn
} from 'react-hook-form';
import { Image, Loading, Typography } from 'tfc-components';

import buttonEmpty from 'assets/images/button_empty.png';
import nhapthongtin from 'assets/images/nhap_thong_tin.png';
import Input from 'components/atoms/Input';

export type CheckInvitationType = {
  phone?: string
};

type Props = {
  method: UseFormReturn<CheckInvitationType>;
  handleCheck: (data: CheckInvitationType) => void;
  handleRegister?: () => void;
  errorText?: string
  errorTextType?: string
  loading?: boolean
};

const Register: React.FC<Props> = ({
  method,
  handleCheck,
  errorTextType,
  loading,
}) => (
  <>
    <div className="p-register_form">
      <FormProvider {...method}>
        <Controller
          name="phone"
          control={method.control}
          render={({ field, fieldState: { error } }) => (
            <div className="p-register_field">
              <div className="p-register_field_input">
                <Input
                  {...field}
                />
                {
                  error && (
                    <div className="p-register_error">
                      <Typography.Text
                        extendClasses="fs-18x26 p-register_error-text"
                        fontweight="600"
                        textStyle="center"
                      >
                        {error.message}
                      </Typography.Text>
                    </div>
                  )
                }
              </div>
            </div>
          )}
        />
      </FormProvider>
    </div>
    <div className="p-register_buttonGroup">
      <div className="p-register_error">
        <Typography.Text
          extendClasses="fs-18x26 p-register_error-text"
          textStyle="center"
          fontweight="600"
        >
          {errorTextType || ''}
        </Typography.Text>
      </div>
      <div
        className={`p-register_checkButton ${loading ? 'p-register_checkButton-loading' : ''}`}
        onClick={async () => {
          if (loading) return;
          const isValid = await method.trigger();

          if (isValid) {
            handleCheck({
              phone: method.getValues('phone')
            });
          }
        }}
      >
        <Image
          imgSrc={loading ? buttonEmpty : nhapthongtin}
          alt="checkBtn"
          ratio={1575 / 280}
        />
        {loading && (
          <Loading.Circle color="#0e3878" width={26} extendClasses="p-register_checkButton_indicator" />
        )}
      </div>
    </div>
  </>
);
export default Register;
